import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'inicio',
      component: () => import(/* webpackChunkname: "login" */ './views/login.view.vue'),
      meta: {
        breadcrumb: [
        ]
      }
    },
    {
      path: '/imprimir/recibos-nomina',
      name: 'printRecibos',
      meta: {
        name: 'SISTEMA INTEGRAL DE NOMINA',
        breadcrumb: []
      },
      component: () => import('./views/recibosNomina.view.vue')
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        allowAnonymous: true,
        name: 'SISTEMA INTEGRAL DE NOMINA',
        breadcrumb: [
          { name: 'Inicio' }
        ]
      },
      component: () => import('./views/home.view.vue')
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      meta: {
        allowAnonymous: true,
        name: 'SISTEMA INTEGRAL DE NOMINA',
        breadcrumb: [
          { name: 'Inicio' }
        ]
      },
      component: () => import('./views/dashboard.view.vue')
    },
    {
      path: '/Configuracion/usuario/perfil',
      name: 'profile',
      meta: {
        allowAnonymous: true,
        name: 'PERFIL DE USUARIO',
        breadcrumb: [
          { name: 'Configuracion' },
          { name: 'Usuario' },
          { name: 'Perfil' }
        ]
      },
      component: () => import('./views/administracion/profile.view.vue')
    },

    /* ========== ** Modules Examples ** ========== */
    {
      path: '/Importador',
      name: 'ExaImport',
      meta: {
        allowAnonymous: true,
        name: 'Importador',
        breadcrumb: [
          { name: 'Ejemplo Importador' }
        ]
      },
      component: () => import('./views/examples/ImportsData.view.vue')
    },
    {
      path: '/Cargar/Archivo',
      name: 'ExaLoadFile',
      meta: {
        allowAnonymous: true,
        name: 'Cargar Archivo',
        breadcrumb: [
          { name: 'Ejemplo Cargar Archivo' }
        ]
      },
      component: () => import('./views/examples/ImportFileData.view.vue')
    },
    /* ========== **END Modules Examples ** ========== */

    /* ========== ** Module Recursos Humanos Module** ========== */
    {
      path: '/RH/Empleados',
      name: 'ViewRHEmpleados',
      meta: {
        allowAnonymous: true,
        name: 'Empleados',
        breadcrumb: [
          { name: 'Recursos Humanos' },
          { name: 'Empleados' }
        ]
      },
      component: () => import('./views/rh/Empleados.view.vue')
    },
    /* ========== **END Module Recursos Humanos Module END** ========== */

    /* ========== ** Module Administracion ** ========== */
    {
      path: '/Administracion/Usuarios',
      name: 'ViewConfigAuthUsers',
      meta: {
        allowAnonymous: true,
        name: 'Usuarios',
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Usuarios' }
        ]
      },
      component: () => import('./views/administracion/auth/users.view.vue')
    },
    {
      path: '/Administracion/Roles',
      name: 'ViewConfigAuthRols',
      meta: {
        allowAnonymous: true,
        name: 'Roles',
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Roles' }
        ]
      },
      component: () => import('./views/administracion/auth/roles.view.vue')
    },
    {
      path: '/Administracion/Permisos',
      name: 'ViewConfigAuthPermiss',
      meta: {
        allowAnonymous: true,
        name: 'Permisos',
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Permisos' }
        ]
      },
      component: () => import('./views/administracion/auth/permisos.view.vue')
    },

    {
      path: '/Administracion/Empresa/Departamentos',
      name: 'ViewConfigDepartments',
      meta: {
        allowAnonymous: true,
        name: 'Departamentos',
        breadcrumb: [{ name: 'Administracion' }, { name: 'Empresa' }, { name: 'Departamentos' }]
      },
      component: () => import('./views/catalogo/departamentos.view.vue')
    },
    {
      path: '/Administracion/Empresa/Ejercicios',
      name: 'ViewConfigEjercicios',
      meta: {
        allowAnonymous: true,
        name: 'Ejercicios',
        breadcrumb: [{ name: 'Administracion' }, { name: 'Empresa' }, { name: 'Ejercicios' }]
      },
      component: () => import('./views/catalogo/ejercicios.view.vue')
    },
    /* ========== **END Module Administracion ** ========== */

    {
      path: '/Administracion/Permisos/Asignar/:id',
      name: 'ViewPermissionsRoleAssign',
      props: true,
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Permisos' }
        ]
      },
      component: () => import('./views/administracion/rolePermissionsAssign.view.vue')
    },

    {
      path: '/Asistencia/Asistencias',
      name: 'ViewNomConfigAsistencia',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'Asistencia de Colaboradores',
        breadcrumb: [
          { name: 'Asistencias' },
          { name: 'Asistencias' }
        ]
      },
      component: () => import('./views/asistencias/asistencias.view.vue')
    },
    {
      path: '/Asistencia/ResumenHoras',
      name: 'ViewNomConfigIncidencias',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'Resumen de Horas de Colaboradores',
        breadcrumb: [
          { name: 'Asistencia' },
          { name: 'Resumen Horas' }
        ]
      },
      component: () => import('./views/asistencias/incidencias.view.vue')
    },
    {
      path: '/Asistencia/LogApp',
      name: 'ViewLogApplication',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'Aplicaciones de Asistencias',
        breadcrumb: [
          { name: 'Asistencia' },
          { name: 'Aplicaciones de Asistencias' }
        ]
      },
      component: () => import('./views/asistencias/logApp.view.vue')
    },
    {
      path: '/Asistencia/Horarios',
      name: 'ViewHorarioAsistencias',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'Horarios de Asistencias',
        breadcrumb: [
          { name: 'Asistencia' },
          { name: 'Hoarios de Asistencias' }
        ]
      },
      component: () => import('./views/asistencias/horariosAsistencia.view.vue')
    },

    /* ========== ** Module Nomina ** ========== */
    {
      path: '/Nomina/Configuracion/Plazas',
      name: 'ViewNomConfigPlazas',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'Plazas',
        breadcrumb: [
          { name: 'Nomina' },
          { name: 'Plazas' }
        ]
      },
      component: () => import('./views/nomina/administracion/plaza.view.vue')
    },
    {
      path: '/Nomina/Configuracion/Puestos',
      name: 'ViewNomConfigPuestos',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'Puestos',
        breadcrumb: [
          { name: 'Nomina' },
          { name: 'Puestos' }
        ]
      },
      component: () => import('./views/nomina/administracion/puestos.view.vue')
    },
    {
      path: '/Nomina/Configuracion/Categorias',
      name: 'ViewNomConfigCategorias',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'Categorias',
        breadcrumb: [
          { name: 'Nomina' },
          { name: 'Categorias' }
        ]
      },
      component: () => import('./views/nomina/administracion/categorias.view.vue')
    },
    {
      path: '/Nomina/Configuracion/Niveles',
      name: 'ViewNomConfigNiveles',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'niveles',
        breadcrumb: [
          { name: 'Nomina' },
          { name: 'Configuración' },
          { name: 'Niveles' }
        ]
      },
      component: () => import('./views/nomina/administracion/niveles.view.vue')
    },
    {
      path: '/Nomina/Configuracion/CuentasEmpleados',
      name: 'ViewNomConfigCuentasEmpleados',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'Cuentas Bancarias Colaboradores',
        breadcrumb: [
          { name: 'Nomina' },
          { name: 'Configuración' },
          { name: 'Cuentas Bancarias' }
        ]
      },
      component: () => import('./views/nomina/administracion/cuentasEmpleados.view.vue')
    },

    {
      path: '/Nomina/Empelado-Plazas',
      name: 'ViewNomEmpleadoPlaza',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'Adscripciones',
        breadcrumb: [
          { name: 'Nomina' },
          { name: 'Empelado-Plazas' }
        ]
      },
      component: () => import('./views/nomina/EmpleadoPlaza.view.vue')
    },

    {
      path: '/Nomina/CalculoNomina',
      name: 'ViewNomNominaGeneradas',
      props: true,
      meta: {
        allowAnonymous: true,
        name: 'Nominas Generadas',
        breadcrumb: [
          { name: 'Nomina' },
          { name: 'Nominas Generadas' }
        ]
      },
      component: () => import('./views/nomina/Nominas.view.vue')
    }
    /* ========== **END Module Nomina ** ========== */
  ]

})
